// Copied from Tailwind's default transition
const transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
const CLOSE_OPTIONS_TRANSITION_TIME = 100;

const selectInputStyles = theme => ({
  '.select-input': {
    border: 'none',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    color: theme('colors.black'),
    padding: '0',

    '&:focus': {
      outline: 'none',
    },

    '&:disabled': {
      color: theme('colors.grey.40'),
      backgroundColor: 'transparent',
    },
  },

  '.select-input-label': {
    transition: 'top 0.2s, font-size 0.2s, font-weight 0.2s, padding 0.2s, color 0.2s',
    transitionTimingFunction,
    color: theme('colors.black'),

    '.select-input-invalid &': {
      color: theme('colors.alertred.60'),
    },
  },

  '.select-input-description': {
    transition: 'opacity 0.1s ease-in, height 0.1s ease-in, margin-top 0.1s ease-in',
    transitionTimingFunction,
    color: theme('colors.green1.55'),

    '.select-input-invalid &': {
      color: theme('colors.alertred.60'),
    },
  },

  '.select-options': {
    transition: `opacity ${CLOSE_OPTIONS_TRANSITION_TIME}ms ease-in, visibility ${CLOSE_OPTIONS_TRANSITION_TIME}ms ease-in`,
  },

  '.insurance-provider-select': {
    '.select-input-label': {
      color: theme('colors.green1.55'),
      '.select-input-invalid &': {
        color: theme('colors.alertred.60'),
        opacity: '1',
      },
    },
  },
});

module.exports = { selectInputStyles };
